import { render, staticRenderFns } from "./PolicyHeader.vue?vue&type=template&id=6976526a&"
import script from "./PolicyHeader.vue?vue&type=script&lang=js&"
export * from "./PolicyHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports